<div class="w-full max-w-screen-xl mx-auto" *ngIf="!form">

    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 w-full min-w-0">
        <div
            class="sm:col-span-2 md:col-span-4 flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden">
            <div class="flex flex-col sm:flex-row items-start justify-between">
                <div class="text-lg font-medium tracking-tight leading-6 truncate">Series de {{ nombreLugar }}
                </div>
                <button mat-flat-button color="accent" (click)="return();"> Regresar</button>
                <button mat-flat-button color="accent" (click)="openFormSerie();"><mat-icon svgIcon="heroicons_solid:plus"></mat-icon> Nueva serie</button>
            </div>
            <div class="grid grid-cols-1 lg:grid-cols-1 grid-flow-row gap-6 w-full mt-8 sm:mt-4">
                <div class="row">

                    <div class="col-12">
                        <app-grid-component
                            *ngIf="verGrid"
                            [datos]="objetoGridConfiguration?.Data"
                            [columns]="objetoGridConfiguration.Columns"
                            [exportExcel]="objetoGridConfiguration.ExportExcel"
                            [columnHiding]="objetoGridConfiguration.ColumnHiding"
                            [Checkbox]="objetoGridConfiguration.Checkbox"
                            [Editing]="objetoGridConfiguration.Editing"
                            [Columnchooser]="objetoGridConfiguration.Columnchooser"
                            [searchPanel]="objetoGridConfiguration.SearchPanel"
                            [scroll]="objetoGridConfiguration.Scroll"
                            (messageEvent)="receiveMessage($event)"
                            (datosevent)="datosMessage($event)"
                            [toolbar]="objetoGridConfiguration.ToolBox"
                            (onRowUpdated)="Actualizar($event)"
                            (modificar)='modificar($event.modificar.key)'
                            (eliminar)='eliminar($event.eliminar.key)'
                            [descargarExcel]="descargarExcel"
                            [nombreReporte]="nombreReporte"
                        ></app-grid-component>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="w-full max-w-3xl" *ngIf="form">
    <!-- Form -->
    <form [formGroup]="serieForm">
        <div class="text-lg font-medium tracking-tight leading-6 truncate">
            <h4>Series de {{ nombreLugar }}</h4>
        </div>

        <div class="grid sm:grid-cols-4 gap-6 w-full mt-8">
            <!-- Razón social -->
            <div class="sm:col-span-4">
                <mat-form-field class="fuse-mat-no-subscript w-full">
                    <mat-label>Serie</mat-label>
                    <input onkeypress="return /[a-zA-Z0-9]/i.test(event.key)" minlength="1" maxlength="25" [formControlName]="'serie'" matInput>
                </mat-form-field>
            </div>

            <!-- Régimen fiscal -->
            <div class="sm:col-span-4">
                <mat-form-field class="fuse-mat-no-subscript w-full">
                    <mat-label>Descripción</mat-label>
                    <input [formControlName]="'descripcion'" matInput>
                </mat-form-field>
            </div>

            <!-- Régimen fiscal -->
            <div class="sm:col-span-4">
                <mat-form-field class="fuse-mat-no-subscript w-full">
                    <mat-label>Folios</mat-label>
                    <input [formControlName]="'folio'" type="number" matInput>
                </mat-form-field>
            </div>
        </div>

        <!-- Divider -->
        <div class="my-10 border-t"></div>

        <!-- Actions -->
        <div class="flex items-center justify-end">
            <button mat-stroked-button (click)="close()" type="button">
                Cancelar
            </button>
            <button class="ml-4" mat-flat-button type="button" (click)="addSerie()" [color]="'primary'" [disabled]="serieForm.pristine || serieForm.invalid">
                Guardar
            </button>
        </div>
    </form>
</div>
